import { render, staticRenderFns } from "./componentMenuTreeNode.vue?vue&type=template&id=5f20f77e&scoped=true"
import script from "./componentMenuTreeNode.vue?vue&type=script&lang=js"
export * from "./componentMenuTreeNode.vue?vue&type=script&lang=js"
import style0 from "./componentMenuTreeNode.vue?vue&type=style&index=0&id=5f20f77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20f77e",
  null
  
)

export default component.exports